module.exports = __webpack_public_path__ + "static/media/default_theme.b5ba2102.png";